/**
 * @Author: DJ
 * @Date:   2021-07-21 17:40:02
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-07-22 09:50:46
 */
import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth, tooltipClick } from '@/components/TableCell';

class TableContent extends React.Component {

    _columns = () => [
        {
            title: '手机号码',
            dataIndex: 'tel',
            key: 'tel',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => { this.props.tableAction('detail', record); })
        },
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '推荐来源',
            dataIndex: 'referrerRole',
            key: 'referrerRole',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '积分',
            dataIndex: 'integral',
            key: 'integral',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'statusStr',
            key: 'statusStr',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '注册时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'userId',
            width: '15%',
            key: 'userId',
            align: 'center',
            render: (id, item) => this._TableAction(item)
        },
    ];

    _takeDataSource = (data) => {
        if (Array.isArray(data)) {
            return data;
        } else {
            return [];
        }
    }

    _TableAction = (record) => {
        const { tableAction } = this.props;
        // // 当为禁用或拉黑时，显示为'启用'
        const disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
        const codeStatusP = record.pickupCodeStatus == '1' ? false : true;
        const codeStatusR = record.receiveCodeStatus == '1' ? false : true;
        const isEnterprise = (record.isEnterprise == '1' || record.isEnterprise == '2') ? true : false;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', record)}>查看详情</div>
                <div className={styles.item} onClick={() => tableAction('available', record)}>{disable ? '启用' : '禁用'}</div>
                {isEnterprise && <div className={styles.item} onClick={() => tableAction('takecode', record)}>{codeStatusP ? '启用取件码' : '禁用取件码'}</div>}
                {isEnterprise && <div className={styles.item} onClick={() => tableAction('pullcode', record)}>{codeStatusR ? '启用收件码' : '禁用收件码'}</div>}
            </div>
        );
    };

    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    columns={this._columns()}
                    rowSelection={rowSelection}
                    rowKey={(r) => r.userId}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    rowSelection: PropTypes.object,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default TableContent;

